module.exports = __webpack_public_path__ + "img/recruit-boss.6508958d.png";